import { render, staticRenderFns } from "./AddWilkaLockDialog.vue?vue&type=template&id=b6c9e6bc&"
import script from "./AddWilkaLockDialog.vue?vue&type=script&lang=js&"
export * from "./AddWilkaLockDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports